import React, { useContext } from 'react';
import styled from 'styled-components';
import DraftOptionFilters from './optionFilters';
import TeamSelectionList from './teamSelectionList';
import { draftStore } from '../../../store';
import { Container } from '../../../components/layout';
import { setStep } from '../../../actions/status';
import { PrimaryButton } from '../../../components/buttons';

const ButtonContainer = styled.div`
    margin: 20px auto 0px;
`

function NewDraft(){
    const { state, dispatch } = useContext(draftStore);
    const teamSelected = state.options.selectedTeams.length;
    return (
        <Container>
            <DraftOptionFilters />
            <TeamSelectionList />
            <ButtonContainer>
                <PrimaryButton
                    padding='10px 48px'
                    onClick={() => teamSelected && dispatch(setStep(state.status.step + 1))}
                    disabled={!teamSelected}
                >
                    Next
                </PrimaryButton>
            </ButtonContainer>
        </Container>
    )
}

export default NewDraft;